/* ============================================================
   AURORA STORIES RAIL — drag-to-scroll controller + entrance
   (owner 2026-07-20). No arrows (EqualWeb focus-square issue);
   the rail drags with the mouse, swipes on touch, and scrolls
   with the wheel/trackpad. Click vs drag is disambiguated so
   the card links keep working.
   ============================================================ */
(function () {
  'use strict';
  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  function initRail(root) {
    var rail = root.querySelector('[data-yst-rail]');
    if (!rail) return;

    /* autoplay kick: some browsers ignore the attribute combo on inserted
       markup — force muted + play once the card is near the viewport */
    var vids = rail.querySelectorAll('video.yst-media');
    function kick(v) {
      try {
        v.muted = true;
        /* stuck download (owner 2026-07-20: a card froze on its poster):
           NETWORK_NO_SOURCE / idle with no data -> reload the element */
        if (v.readyState < 2 && (v.networkState === 3 || v.networkState === 0)) v.load();
        var p = v.play();
        if (p && p.catch) p.catch(function () {
          v.addEventListener('canplay', function once() {
            v.removeEventListener('canplay', once);
            v.play().catch(function () {});
          });
        });
      } catch (e) { /* noop */ }
    }
    if ('IntersectionObserver' in window) {
      var vio = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (en.isIntersecting) kick(en.target);
          else if (en.target.pause) en.target.pause();
        });
      }, { rootMargin: '200px 0px' });
      for (var kv = 0; kv < vids.length; kv++) {
        vio.observe(vids[kv]);
        vids[kv].addEventListener('stalled', (function (v) { return function () { kick(v); }; })(vids[kv]));
      }
      document.addEventListener('visibilitychange', function () {
        if (document.hidden) return;
        for (var rv = 0; rv < vids.length; rv++) {
          var r = vids[rv].getBoundingClientRect();
          if (r.bottom > 0 && r.top < window.innerHeight && vids[rv].paused) kick(vids[rv]);
        }
      });
    } else {
      for (var kv2 = 0; kv2 < vids.length; kv2++) kick(vids[kv2]);
    }

    /* persistent keeper (owner 2026-07-20: "the UGC are frozen" while the
       hero plays) — same layer that finally unfroze the hero film: every
       1.2s revive any on-screen card that never started or silently
       paused. The IO above pauses cards once they leave the 200px margin;
       the keeper only touches cards strictly inside the viewport, so the
       two never fight. */
    setInterval(function () {
      if (document.hidden) return;
      for (var ki = 0; ki < vids.length; ki++) {
        var kvid = vids[ki];
        var kr = kvid.getBoundingClientRect();
        if (kr.bottom <= 0 || kr.top >= window.innerHeight || kr.right <= 0 || kr.left >= window.innerWidth) continue;
        var neverStarted = kvid.currentTime < 0.1 && kvid.readyState < 2;
        if (kvid.paused || neverStarted) {
          if (kvid.readyState === 0 && kvid.networkState !== 2) { try { kvid.load(); } catch (e) { /* noop */ } }
          kvid.muted = true;
          var kp = kvid.play();
          if (kp && kp.catch) kp.catch(function () {});
        }
      }
    }, 1200);

    /* GESTURE UNLOCKER (owner 2026-07-20, paired with the hero's): on
       devices whose browser refuses all programmatic autoplay (iOS Low
       Power Mode, energy/data saver) the first real tap / touch / key
       press revives every on-screen card; play() inside a user gesture
       is always allowed. Detaches once a start succeeds. */
    (function () {
      var unlocked = false;
      function unlockAll() {
        if (unlocked) return;
        var revived = 0;
        for (var ui = 0; ui < vids.length; ui++) {
          var uv = vids[ui];
          var ur = uv.getBoundingClientRect();
          if (ur.bottom <= 0 || ur.top >= window.innerHeight) continue;
          if (!uv.paused) { revived++; continue; }
          try {
            uv.muted = true;
            uv.play().then(function () { unlocked = true; }).catch(function () {});
            revived++;
          } catch (eG) { /* noop */ }
        }
        if (unlocked || revived === 0) return; /* keep listening until one truly starts */
      }
      document.addEventListener('touchstart', unlockAll, true);
      document.addEventListener('pointerdown', unlockAll, true);
      document.addEventListener('keydown', unlockAll, true);
    })();

    /* entrance */
    if ('IntersectionObserver' in window && !reducedMotion.matches) {
      var targets = rail.querySelectorAll('.yst-card');
      for (var i = 0; i < targets.length; i++) {
        targets[i].style.transitionDelay = (Math.min(i, 8) * 0.07) + 's';
      }
      new IntersectionObserver(function (entries, obs) {
        entries.forEach(function (en) {
          if (en.isIntersecting) { root.classList.add('is-in'); obs.disconnect(); }
        });
      }, { threshold: 0.15 }).observe(root);
    } else { root.classList.add('is-in'); }

    /* drag to scroll (desktop) */
    var down = false, moved = false, startX = 0, startLeft = 0;
    rail.addEventListener('pointerdown', function (e) {
      if (e.pointerType !== 'mouse') return; /* touch scrolls natively */
      down = true; moved = false;
      startX = e.clientX; startLeft = rail.scrollLeft;
      rail.classList.add('is-dragging');
    });
    window.addEventListener('pointermove', function (e) {
      if (!down) return;
      var dx = e.clientX - startX;
      if (Math.abs(dx) > 4) moved = true;
      rail.scrollLeft = startLeft - dx;
    });
    window.addEventListener('pointerup', function () {
      down = false;
      rail.classList.remove('is-dragging');
    });
    /* a real drag must not trigger the card link */
    rail.addEventListener('click', function (e) {
      if (moved) { e.preventDefault(); e.stopPropagation(); moved = false; }
    }, true);

    /* vertical wheel -> horizontal glide */
    rail.addEventListener('wheel', function (e) {
      if (Math.abs(e.deltaY) > Math.abs(e.deltaX)) {
        rail.scrollLeft += e.deltaY;
        e.preventDefault();
      }
    }, { passive: false });

    /* keyboard access */
    rail.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { rail.scrollBy({ left: 320, behavior: 'smooth' }); e.preventDefault(); }
      if (e.key === 'ArrowLeft') { rail.scrollBy({ left: -320, behavior: 'smooth' }); e.preventDefault(); }
    });
  }

  function init() {
    var roots = document.querySelectorAll('[data-yst]');
    for (var i = 0; i < roots.length; i++) initRail(roots[i]);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
